module.exports = __webpack_public_path__ + "assets/img/202112-2.b782005b.png";